import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import './plugins/base'
import firebase from 'firebase'
import vuetify from './plugins/vuetify'
import VueParticles from 'vue-particles'
import 'video.js/dist/video-js.css'
import heatmapjsVue from 'heatmapjs-vue'
import Clipboard from 'v-clipboard'

Vue.use(Clipboard)
Vue.use(VueParticles)
Vue.use(heatmapjsVue)
Vue.config.productionTip = false
// NOTE: Fail to display vue-particls as background on production.
// The error seems to be related with 'strict mode'.
// Then change strict settings but it might not affect.Still doesn' show particles.
// Vue.config.strict = false

// vue app is created upon firestore auth is settled

let vue = null

firebase.auth().onAuthStateChanged(user => {
  if (user) {
    store.dispatch('users/setActiveUser', { user })

    // retrieve user claims
    if (typeof user?.getIdTokenResult === 'function') {
      user.getIdTokenResult().then(result => {
        store.dispatch('users/setActiveAdmin', { admin: result.claims.admin })
      })
    }
  } else {
    store.dispatch('users/setActiveUser', { user: {} })
    store.dispatch('users/setActiveAdmin', { admin: {} })
  }

  if (!vue) {
    vue = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})
